import { matchesSearch } from './stringSearch'

// A single default for searchable selectors and tables, including future screens.
export const stringSearchDefaults = {
  VAutocomplete: { customFilter: matchesSearch },
  VCombobox: { customFilter: matchesSearch },
  VDataTable: { customFilter: matchesSearch },
  VDataTableVirtual: { customFilter: matchesSearch },
  VDataIterator: { customFilter: matchesSearch },
}
